import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout.component';

const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    children: [
      {
        path: '', redirectTo: 'user', pathMatch: 'full'
      },
      // TODO REMOVE COMMENT AFTER UAT1
      // {
      //   path: 'dashboard', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      {
        path: 'user', loadChildren: () => import('../user/user.module').then(m => m.UserModule)
      },
      {
        path: 'booking', loadChildren: () => import('../booking/booking.module').then(m => m.BookingModule)
      }
      ,
      {
        path: 'inventory', loadChildren: () => import('../inventory/inventory.module').then(m => m.InventoryModule)
      }
      ,
      {
        path: 'contracts', loadChildren: () => import('../contracts/contracts.module').then(m => m.ContractsModule)
      }
      ,
      {
        path: 'accounting', loadChildren: () => import('../accounting/accounting.module').then(m => m.AccountingModule)
      },
      {
        path: 'cms', loadChildren: () => import('../cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'subscription', loadChildren: () => import('../subscription/subscription.module').then(m => m.PlansModule)
      }
      ,
      {
        path: 'rating', loadChildren: () => import('../rating/rating.module').then(m => m.RatingModule)
      }
      ,
      {
        path: 'leads', loadChildren: () => import('../leads/leads.module').then(m => m.LeadsModule)
      }
      ,
      {
        path: 'reports', loadChildren: () => import('../reports/reports.module').then(m => m.ReportsModule)
      }
      ,
      {
        path: 'feeds', loadChildren: () => import('../feeds/feeds.module').then(m => m.FeedsModule)
      }
      ,
      {
        path: 'acl', loadChildren: () => import('../acl/acl.module').then(m => m.AclModule)
      },
      {
        path: 'profile', loadChildren: () => import('../profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'configuration', loadChildren: () => import('../configuration/configuration.module').then(m => m.ConfigurationModule)
      },
      {
        path: 'territory', loadChildren: () => import('../territory/territory.module').then(m => m.TerritoryModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
